import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ResponseAvis} from "../../../common/services/avis/response-avis.model";

@Component({
  selector: 'app-modal-historic',
  templateUrl: './modal-historic.component.html',
  styleUrls: ['./modal-historic.component.scss']
})
export class ModalHistoricComponent {
  dialogRef = inject(MatDialogRef<ModalHistoricComponent>);
  data = inject(MAT_DIALOG_DATA);
  avis: ResponseAvis;

  constructor() {
    if (this.data) {
      this.avis = this.data;
    }
  }
  close() {
    this.dialogRef.close();
  }
}
